const emailList = () => import("@/pages/email/index.vue");
const emailDetail = () => import("@/pages/email/detail.vue");

export default [
    {
        path: "/email/list",
        component: emailList,
        meta: [
            {
                name: "邮件管理",
            },
            {
                name: "邮件列表",
                activeRoute: "/email/list",
            },
        ],
    },
    {
        path: "/email/detail",
        component: emailDetail,
        meta: [
            {
                name: "邮件管理",
            },
            {
                name: "邮件列表",
                url: "/email/list",
            },
            {
                name: "邮件详情",
                activeRoute: "/email/list",
            },
        ],
    },
];
